.tableContainer {
    width: 100%;
}
.headerContainer {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 38px;
    background-color: #E6EDF1;
    border-top: 1px solid #dee2e6;
    border-bottom: 2px solid #dee2e6;
}
.toggleHeader {
    width: 75px;
}
.titleContainer {
    width: 800px;
    padding: 10px;
}
.limitContainer {
    display: flex;
    flex: 2 1 auto;
    width: 200px;
    padding: 10px;
}
.overflowHeader {
    display: flex;
    flex: 2 1 auto;
    width: 50px;
    padding: 10px;
}

.pageSectionHeader {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 10px 0px;
}